import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      home: "Home",
      philosophy: "Our Philosophy",
      shop: "The Shoppe",
      consultation: "Consultations Offered",
      blog: "Blog",
      contact: "Contact Us",
      search: "Search Products...",
      track: "Track Your Order",
      healthy: "Healthy • Vedic • Lifestyle"
    }
  },

  hi: {
    translation: {
      home: "होम",
      philosophy: "हमारा दर्शन",
      shop: "दुकान",
      consultation: "परामर्श",
      blog: "ब्लॉग",
      contact: "संपर्क करें",
      search: "उत्पाद खोजें...",
      track: "ऑर्डर ट्रैक करें",
      healthy: "स्वस्थ • वैदिक • जीवनशैली"
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") || "en",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;